import React from 'react';
import HeaderBottom from '../components/HomePage/HeaderBottom';
import ContactUs from './ContactUs';

const ContactUsPage = () => {
  return (
    <div className="boxed_wrapper ltr">
      <HeaderBottom />
      <ContactUs />
    </div>
  );
};

export default ContactUsPage;
